function RegisterModal(loginRegisterModule) {

    var self = new ModalModule();

    self.catering = ko.observable();
    self.user = ko.observable();
    self.templateIntro = ko.observable('register-intro');

    self.headerLabel('Nuovo Utente? TrovaciGusto!');
    self.bodyTemplate('registerModalTemplate');
    self.headerTemplate('headerRegisterModalTemplate');
    self.modalSize = ko.observable('modal-sm');
    self.showOtherButton = ko.observable(false);
    self.showAppBadge = ko.observable(navigator.userAgent.indexOf("gonative") === -1 && /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent));
    self.loginRegisterModule = loginRegisterModule ? loginRegisterModule : new LoginRegisterModule();

    // Aprire il modale e' il segnale che l'utente vuole iscriversi: si pre-caricano gli SDK
    // dei login social, cosi' il click sui pulsanti apre subito il popup.
    self.modalVisible.subscribe(function (visible) {
        if (visible) {
            self.loginRegisterModule.preloadSocialSdks();
        }
    });

    self.show = function () {
        closeAllModal()
        self.loginRegisterModule.acceptedPrivacy(false)
        self.modalVisible(true)

    }

    return self;
}